import { render, staticRenderFns } from "./returnMaterialDetail.vue?vue&type=template&id=2a193aab&scoped=true&"
import script from "./returnMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./returnMaterialDetail.vue?vue&type=script&lang=js&"
import style0 from "./returnMaterialDetail.vue?vue&type=style&index=0&id=2a193aab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a193aab",
  null
  
)

export default component.exports